/* eslint-disable react/no-array-index-key */
import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { nextiasLogo } from '../../../utils/constants';
import { getOrganizationPropertiesByHost } from '../../../utils/helpers';
import { useMiscellaneousData } from '../../../contexts/ssr-miscellaneous-context';

export default function Footer({ footerData }) {
  const { miscellaneousData } = useMiscellaneousData();
  const currentOrg = getOrganizationPropertiesByHost(miscellaneousData?.hostname);
  const isNextIas = currentOrg?.organizationName === 'nextias';
  const organizationId = currentOrg?.orgId || '9a523aa7-dc66-410a-98bb-8cd66e875f35';

  return (
    <>
      <footer className={`${organizationId === '9a523aa7-dc66-410a-98bb-8cd66e875f35' ? 'bg-[#f3fbff]' : 'bg-[#eff1f4]'} py-10`}>
        <div className="xl:max-w-[1320px] lg:max-w-[960px] container px-4 xl:px-[18px] mx-auto">
          <div className={`grid ${isNextIas ? 'md:grid-cols-[40%_60%] grid-cols-1' : 'grid-cols-1 lg:grid-cols-[40%_60%]'}`}>
            <div className={`w-full ${!isNextIas ? 'mb-[40px] lg:w-1/2' : 'md:mb-0 mb-3 md:w-1/2'}`}>
              <Link href={`${currentOrg?.organizationName === 'nextias' ? `https://${miscellaneousData?.hostname}` : `https://${miscellaneousData?.hostname}`}`}>
                <Image width={500} height={500} src={currentOrg?.logo || nextiasLogo} alt="logo" className="w-[144px] h-6 xl:w-[175px] xl:h-10" />
              </Link>
              {
                isNextIas ? (
                  <>
                    <p className="text-sm font-light mt-3 text-[#344767]">Next Generation Institute for UPSC Civil Services Examination Preparation.</p>
                    <div className="flex items-center gap-1 mt-8">
                      <Link href="https://play.google.com/store/apps/details?id=com.nextias.app&hl=en_IN&gl=US">
                        <Image src="https://cdnstatic.madeeasyprime.com//googleplay-download-1756497156927.svg" width={110} height={31} alt="google-play-store-app" />
                      </Link>
                      <Link href="https://apps.apple.com/in/app/next-ias/id1527559034">
                        <Image src="https://cdnstatic.madeeasyprime.com//appstore-download-1756497139252.svg" width={110} height={31} alt="app-store" />
                      </Link>
                    </div>
                  </>
                ) : (
                  footerData?.brand && (
                  <ul className="mt-6">
                    <li className="mb-3 flex items-start gap-3">
                      <Image src="https://cdnstatic.nextias.com//location-on-FILL-1756760508043.svg" width={16} height={16} alt="location" />
                      <span className="text-sm">
                        <strong className="font-semibold">
                          {footerData?.brand?.corporate_office?.name}
                          :-
                        </strong>
                        <br />
                        <span className="font-light">
                          {footerData?.brand?.corporate_office?.address}
                        </span>
                      </span>
                    </li>
                    <li className="mb-3 flex items-start gap-3">
                      <Image src="https://cdnstatic.nextias.com//phone-in-talk-1756760527535.svg" width={16} height={16} alt="contact" />
                      <span className="text-sm font-light">{footerData?.brand?.contact?.phone}</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <Image src="https://cdnstatic.nextias.com//email-fill-1756760572032.svg" width={16} height={16} alt="email" />
                      <span className="text-sm font-light">{footerData?.brand?.contact?.email}</span>
                    </li>
                  </ul>
                  )
                )
              }
            </div>
            <div className={`grid gap-x-6 mt-6 md:mt-0 ${isNextIas ? 'grid-cols-3 gap-y-2' : 'md:grid-cols-3 grid-cols-2 gap-y-8'}`}>
              {footerData?.links?.columns?.map((col, colIndex) => {
                const isLast = colIndex === footerData.links.columns.length - 1;
                return (
                  <div key={colIndex}>
                    <h3 className="text-lg font-semibold text-[#393837]">{col.title}</h3>
                    <ul key={colIndex} className={`space-y-1 ${!isLast && !isNextIas ? 'border-r border-gray-200' : ''}`}>
                      {col.links.map((item, linkIndex) => (
                        <li key={linkIndex}>
                          <Link
                            href={item.url}
                            className={`text-[#344767] text-sm font-light leading-[1.5] ${isNextIas ? 'hover:text-red-500' : 'hover:text-[#0a58ca]'}`}
                          >
                            {item.text}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              })}
            </div>

          </div>
          <hr className="border-t-2 border-gray-300 my-8" />
          {
            footerData?.centers && organizationId !== '9a523aa7-dc66-410a-98bb-8cd66e875f35' && (
              <div>
                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 lg:gap-10 pb-8 gap-8">
                  {footerData && footerData.centers && footerData.centers.length > 0 && footerData.centers.map((branch, idx) => (
                    <div key={idx} className="flex flex-col gap-3 text-[#344767]">
                      {/* Icon + Title */}
                      <div className="flex flex-col items-start gap-2">
                        <Image src={branch.icon} alt="centers" width={48} height={48} />
                        <p className="text-lg font-normal">{branch.title}</p>
                      </div>

                      {branch.branch && (
                      <p className="font-normal text-base">{branch.branch}</p>
                      )}

                      <div
                        className="text-sm leading-relaxed font-light"
                        dangerouslySetInnerHTML={{ __html: branch.address }}
                      />

                      {branch.phone && (
                      <Link
                        href={`tel:${branch.phone}`}
                        className="text-blue-600 hover:text-blue-800 text-sm flex items-center"
                      >
                        <Image src="https://cdnstatic.madeeasyprime.com//icon-call-1756539389478.svg" className="mr-1" alt="call-icon" width={15} height={15} />
                        {branch.phone}
                      </Link>
                      )}

                      {branch.email && (
                      <Link
                        href={`mailto:${branch.email}`}
                        className="text-blue-600 hover:text-blue-800 text-sm flex items-center"
                      >
                        <Image src="https://cdnstatic.madeeasyprime.com//icon-email-1756539407370.svg" className="mr-1" alt="call-icon" width={15} height={15} />
                        {branch.email}
                      </Link>
                      )}
                    </div>
                  ))}
                </div>
                <div className="grid md:grid-cols-2 grid-cols-1 mb-6">
                  {
                    footerData && footerData?.copyright && (
                    <p className="text-[#344767] text-sm font-light mb-4 md:mb-0">{footerData.copyright}</p>
                    )
                }
                  <ul className="flex items-center gap-4 md:justify-end justify-start">
                    {
                    footerData && footerData?.social_links && footerData?.social_links?.length > 0 && footerData?.social_links?.map((socialLinks, index) => (
                      <li key={index}>
                        <Link href={socialLinks.url}>
                          <Image src={socialLinks.icon} alt="social-links" width={18} height={18} />
                        </Link>
                      </li>
                    ))
                }
                  </ul>
                </div>
              </div>
            )
          }
        </div>
        {
          footerData?.college_relations
          && organizationId === '9a523aa7-dc66-410a-98bb-8cd66e875f35' && (
            <div className="xl:max-w-[1320px] lg:max-w-[960px] container px-4 xl:px-[18px] pt-4 mx-auto">
              <div className="grid lg:grid-cols-2 grid-cols-1">
                <div className="lg:mb-0 mb-8">
                  <p className="text-base text-black font-semibold mb-3">{footerData.college_relations.title}</p>
                  <p className="text-sm text-[#344767] font-light mb-3">{footerData.college_relations.description}</p>
                  <p className="text-sm text-[#344767] font-light">{footerData.college_relations.email}</p>
                </div>
                <div className="flex items-center gap-3">
                  {footerData?.apps?.app_store && (
                  <Link href={footerData.apps.app_store.url} className="h-10 w-auto">
                    <Image
                      src={footerData.apps.app_store.icon}
                      alt="App Store"
                      width={150}
                      height={47}
                      className="h-10 w-auto object-contain"
                    />
                  </Link>
                  )}

                  {footerData?.apps?.google_play && (
                  <Link href={footerData.apps.google_play.url} className="h-10 w-auto">
                    <Image
                      src={footerData.apps.google_play.icon}
                      alt="Google Play"
                      width={150}
                      height={47}
                      className="h-10 w-auto object-contain"
                    />
                  </Link>
                  )}
                </div>

              </div>
            </div>
          )
        }
      </footer>

      <div className="bg-[#015ba5] px-3 lg:py-3 py-6 sticky bottom-0 left-0 ">
        <div className="xl:max-w-[1320px] lg:max-w-[960px] container px-4 xl:px-[18px] mx-auto">
          <div className="max-w-[1320px] container xl:px-[18px] mx-auto grid lg:grid-cols-[3fr_1fr] grid-cols-1 items-center md:justify-between justify-center">
            {
              organizationId && organizationId === '9a523aa7-dc66-410a-98bb-8cd66e875f35' ? (
                <>
                  <ul className="flex items-center lg:mb-0 mb-4 justify-center lg:justify-start flex-wrap lg:flex-nowrap">
                    {
                        footerData && footerData.bottom_links && footerData.bottom_links.length > 0 && footerData.bottom_links.map((bottomLinks, bottomLinkIndex) => {
                          const isLast = bottomLinkIndex === footerData.bottom_links.length - 1;
                          return (
                            <li key={bottomLinkIndex}>
                              <Link href={`https://${miscellaneousData?.hostname}/${bottomLinks.url}`} className={`text-white text-sm font-light inline-block mb-4 lg:mb-0 px-3 ${isLast ? '' : 'border-r border-white'} ${bottomLinks.url === '#' ? 'cursor-text' : 'cursor-pointer'}`}>{bottomLinks.text}</Link>
                            </li>

                          );
                        })
                    }
                  </ul>
                  {
                    footerData?.social_links && footerData.social_links.length > 0 && (
                      <ul className="flex items-center lg:justify-end justify-center gap-4">
                        {
                        footerData.social_links.map((socialLinks, Index) => (
                          <li key={Index}>
                            <Link href={socialLinks.url}>
                              <Image src={socialLinks.icon} width={Index === 0 ? 9 : 18} height={18} alt="social-links" />
                            </Link>
                          </li>
                        ))
                      }
                      </ul>
                    )
                  }

                </>
              ) : (
                <div className="flex items-center lg:justify-start">
                  <Image src="https://cdnstatic.madeeasyprime.com//notification-1756538683125.png" alt="public-notice" width={30} height={35} className="flex-shrink-0" />
                  <Link href="https://cdnstatic.nextias.com/newuploads/Nextias/2025/1/privacy-crime-new-pdf-1736922169832.pdf?_gl=1*15q4ec1*_gcl_au*NzkyODUzNzE3LjE3NDkyMDIxOTI." className="relative">
                    <p className="text-sm font-normal text-white">Public Notice Against Piracy</p>
                    <Image className="absolute top-0 right-0 translate-x-[34px]" src="https://cdnstatic.madeeasyprime.com//new-batch-1756538849086.gif" alt="new-batch-icon" width={33} height={16} />
                  </Link>
                </div>
              )
          }
          </div>
        </div>
      </div>
    </>
  );
}

Footer.propTypes = {
  footerData: PropTypes.object,
};
